<template>
	<create-edit-layout v-if="showCreateEditAdminUsers" element="AdminUsers" icon="fas fa-user" @duplicatecomplete="$emit('duplicatecomplete')">
		<v-col cols="12" xs="12" sm="4" v-if="!currentAdminUsers.id">
			<ValidationProvider ref="tenant_id" vid="tenant_id" :name="$t('incomedeclarations.tenant')" rules="required" v-slot="{ errors, field }">
				<v-combobox hide-details v-model="tenant" :label="$t('incomedeclarations.tenant')" :items="$appOptions.autocompleteAdminClients()" item-text="fullname" item-value="id" @change="currentAdminUsers.tenant_id = tenant.id" :error-messages="errors" :menu-props="'closeOnClick, overflowY'"></v-combobox>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" :sm="currentAdminUsers.id ? 6 : 4">
			<ValidationProvider ref="surname" vid="surname" :name="$t('adminusers.surname')" rules="required" v-slot="{ errors, field }">
				<v-text-field class="required" :label="$t('adminusers.surname')" v-model="currentAdminUsers.surname" :error-messages="errors" :autofocus="$appOptions.canAutofocus()"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" :sm="currentAdminUsers.id ? 6 : 4">
			<ValidationProvider ref="name" vid="name" :name="$t('adminusers.name')" rules="required" v-slot="{ errors, field }">
				<v-text-field class="required" :label="$t('adminusers.name')" v-model="currentAdminUsers.name" :error-messages="errors" :autofocus="$appOptions.canAutofocus()"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="6">
			<ValidationProvider vid="email" :name="$t('adminusers.email')" rules="email|required" v-slot="{ errors, field }">
				<v-text-field type="email" class="required" :label="$t('adminusers.email')" v-model="currentAdminUsers.email" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="6">
			<ValidationProvider vid="phone_number" :name="$t('adminusers.phone_number')" rules="" v-slot="{ errors, field }">
				<v-text-field type="tel" :label="$t('adminusers.phone_number')" v-model="currentAdminUsers.phone_number" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
	</create-edit-layout>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		currentAdminUsers: {
			get: function () {
				return this.$store.getters.getCurrentAdminUsers;
			},
			set: function (value) {
				this.$store.commit("setCurrentAdminUsers", value);
			},
		},
		showCreateEditAdminUsers() {
			return this.$store.getters.showCreateEditAdminUsers;
		},
	},
};
</script>
